import { Button } from "flowbite-react"
import Link from "next/link"
import React, { useEffect, useState } from "react"

import { CheckSmallIcon } from "@assets/icons"
import { StepsOptionsType } from "@mono/essentials/types/GlobalConfigTypes"
import CheckmarkSvg from "@public/svg/checkmark.svg"
/* eslint-disable no-undef */

interface StepState {
  description: string
  completed: boolean
  highlighted: boolean
  selected: boolean
  link?: string
  onClick?: () => void
}

interface StepperProps {
  steps: StepsOptionsType[]
  currentStep: number
  stepWrapperClassName?: string
  hasLink?: boolean
  baseUrl?: string
  wrapperClassName?: string
  innerClassName?: string
  isWidget?: boolean
}

const Stepper = ({
  steps,
  currentStep,
  stepWrapperClassName,
  hasLink,
  baseUrl,
  wrapperClassName,
  innerClassName,
  isWidget,
}: StepperProps) => {
  const [newStep, setNewStep] = useState<StepState[]>([])

  const updateData = () => {
    const StepState = steps.map((step, index) => ({
      description: step.label,
      link: step?.value,
      onClick: step?.onClick,
      completed: index < currentStep,
      highlighted: currentStep === index,
      selected: currentStep === index,
    }))
    setNewStep(StepState)
  }

  useEffect(() => {
    updateData()
  }, [steps, currentStep])

  const displaySteps = newStep.map((step, index) => (
    <React.Fragment key={index}>
      <div
        className={`${index !== newStep.length - 1 ? "flex w-full max-w-xs items-center" : "flex items-center"} w-max py-2 sm:py-0`}
        key={index}
      >
        <div className={`text-gray relative flex flex-col items-center`}>
          <div
            className={`flex h-5 w-5 2xl:h-6 2xl:w-6 items-center justify-center rounded-full  border text-sm transition duration-500 ease-in-out ${
              index < currentStep
                ? "border border-primary-600"
                : step.selected
                  ? "border border-primary-600 bg-primary-600 text-white"
                  : ""
            }  ${isWidget ? "sm:border border-0" : ""}`}
          >
            {step.completed ? (
              <span>
                {step.completed ? (
                  <CheckSmallIcon className={"text-primary-600"} />
                ) : step.selected ? (
                  index + 1
                ) : (
                  ""
                )}
              </span>
            ) : (
              // <span>{step.completed ? <CheckSmallIcon className='text-primary-600' /> : step.selected ? index + 1 : ''}</span>
              index + 1
            )}
          </div>
        </div>
        <div
          className={` 2xl:px-3 px-2 text-center 2xl:text-sm text-xs ${step.highlighted ? "" : "text-neutral-800"} ${
            step.onClick ? "cursor-pointer hover:text-primary-600" : ""
          } w-max ${isWidget && index === currentStep ? "block" : "hidden sm:block"}`}
          onClick={step.onClick}
        >
          {hasLink ? (
            <Link
              className={"cursor-pointer hover:text-primary-600"}
              href={`${baseUrl}${step?.link as string}`}
            >
              {step.description}
            </Link>
          ) : (
            step.description
          )}
        </div>
      </div>
      {index !== newStep.length - 1 && (
        <div
          className={`mx-2.5 w-full ${newStep.length < 3 ? "max-w-lg" : "max-w-xs"} flex-auto border-t-2 transition duration-500 ease-in-out ${
            step.completed ? "border-primary-600" : "border-gray900"
          } ml-0 `}
        />
      )}
    </React.Fragment>
  ))

  return (
    // <div className={`overflow-auto stepper-main-section ${wrapperClassName ?? ''}`}>
    <div
      className={`overflow-auto stepper-main-section ${wrapperClassName ?? ""} ${
        isWidget ? "stepper-main-widget-section" : "stepper-main-section"
      }`}
    >
      <div className={`w-full bg-white ${stepWrapperClassName || "xl:w-9/12 2xl:w-3/4"}`}>
        <div className={"horizontal"}>
          <div className={`${innerClassName} items-center sm:flex`}>{displaySteps}</div>
        </div>
      </div>
    </div>
  )
}

export default Stepper
